var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRotateNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBB23D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.3,154.1c-2.6,0-4.6,0-6.8,0c-40,0-79.9,0.1-119.9-0.1c-5.7,0-11.6-0.8-17-2.4c-9.5-2.9-13.2-11.2-9-20.2 c2.4-4.9,5.7-9.5,9.5-13.4c11.6-12,23.5-23.6,35.7-35.8c-18.2-12.1-37.6-16.4-58.2-13.6c-45.1,6.3-77.1,43.4-75.8,88.6 c1,34.1,17.5,60,48,75c32.8,16.2,64.7,12.3,93.5-10.4c6.6-5.2,11.8-12.1,17-18.8c7.4-9.6,16.2-15.8,28.8-14.5 c11.4,1.2,19.5,7.4,23.9,17.7c3.8,8.8,3.6,17.8-1.6,25.7c-17.4,26.5-40.7,46.5-70.5,57.6c-41.6,15.6-82.8,13.7-121.5-8.2 c-51-29-77.2-74-75-132.8C2.3,94.4,29,53.2,76.5,27.4c41.6-22.6,85.3-23.6,128.8-3.8c8.7,3.9,16.8,9.2,24.7,14.4 c3.1,2.1,4.6,1.5,6.9-0.8c8.9-9,17.6-18.1,26.8-26.7c3.8-3.6,8.2-6.9,13.1-9c8.8-3.8,16.4-0.4,19.4,8.7c2.1,6.2,3.4,12.9,3.5,19.4 c0.3,40.3,0.1,80.7,0.1,121.1C299.8,151.4,299.6,152.3,299.3,154.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateNew);
export default __webpack_public_path__ + "static/media/icon-rotate-new.751e7f5632d07b06fd6410d05727d9be.svg";
export { ForwardRef as ReactComponent };